import { RuleResult } from 'types/DeclarationP5'
import { CL181_BULK_KIND_OF_PACKAGES, CL182_UNPACKED_KIND_OF_PACKAGES } from 'shared/ncts/common/constants'
import { removePrefix } from 'shared/ncts/common/classifier-util'

const C0060Validator = {
  validatePackagingShippingMarksRequirement: (typeOfPackages?: string | null): RuleResult => {
    const packageType = removePrefix(typeOfPackages, 'PACKAGE_TYPE_')
    if (packageType && (
      CL181_BULK_KIND_OF_PACKAGES.includes(packageType)
      || CL182_UNPACKED_KIND_OF_PACKAGES.includes(packageType)
    )) {
      return 'OPTIONAL'
    }

    return 'REQUIRED'
  },
  validatePackagingNumberOfPackagesRequirement: (typeOfPackages?: string | null): RuleResult => {
    const packageType = removePrefix(typeOfPackages, 'PACKAGE_TYPE_')
    if (packageType && CL181_BULK_KIND_OF_PACKAGES.includes(packageType)) {
      return 'NOT_ALLOWED'
    }

    return 'REQUIRED'
  },

} as const

export default C0060Validator
